/**
 * @generated SignedSource<<f040c867dad305c1fb201e4f573f0972>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WeekDrawer_week$data = {
  readonly description: string | null | undefined;
  readonly " $fragmentType": "WeekDrawer_week";
};
export type WeekDrawer_week$key = {
  readonly " $data"?: WeekDrawer_week$data;
  readonly " $fragmentSpreads": FragmentRefs<"WeekDrawer_week">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WeekDrawer_week",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Week",
  "abstractKey": null
};

(node as any).hash = "17e623f1bcb73b345d353705078b2492";

export default node;
